// import { hexToRGB } from '@/utils.js'

function hexToRGB(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}

// text-white -> textWhite
function kebabToCamelCase(s){
  return s.replace(/-./g, x=>x[1].toUpperCase())
}

// [5,10] -> 7.5
function avgArray(arr){
  return arr.reduce((n, sum) => n + sum, 0) / arr.length
}


export {
	hexToRGB,
  kebabToCamelCase,
  avgArray
}
